export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

/**
 * Formats a UTC date string as a full date + time in the given IANA timezone.
 * Falls back to the browser's local time when timezone is absent or invalid.
 */
export function formatDateTime(dateString, timezone) {
  const date = new Date(dateString);
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };
  if (timezone) {
    try {
      // Validate the timezone string before using it
      Intl.DateTimeFormat(undefined, { timeZone: timezone });
      options.timeZone = timezone;
    } catch {
      // Invalid timezone — fall back to browser local time
    }
  }
  return date.toLocaleString("en-GB", options);
}
